import { useQuery } from '@tanstack/react-query';
import { getListForConclusionFlags } from 'Services';
import { RQ_ALL_CONCLUSION_FLAGS } from 'Utils';

function useGetConclusionFlags() {
    return useQuery([RQ_ALL_CONCLUSION_FLAGS], getListForConclusionFlags, {
        onSuccess: (data) => data?.data
    });
}

export default useGetConclusionFlags;
